"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowSelectionCheckbox = exports.HeaderSelectionCheckbox = exports.CheckboxWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("../..");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var HeaderSelectionCheckbox = function HeaderSelectionCheckbox(_ref) {
  var table = _ref.table;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Checkbox, {
    checked: table.getIsAllPageRowsSelected() ? true : table.getIsSomeRowsSelected() ? 'indeterminate' : false,
    onChange: function onChange(value) {
      return table.toggleAllPageRowsSelected(!!value);
    },
    "aria-label": "Select all"
  });
};
exports.HeaderSelectionCheckbox = HeaderSelectionCheckbox;
var RowSelectionCheckbox = function RowSelectionCheckbox(_ref2) {
  var row = _ref2.row;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Checkbox, {
    checked: row.getIsSelected() || row.getIsAllSubRowsSelected() ? true : row.getIsSomeSelected() ? 'indeterminate' : false,
    disabled: !row.getCanSelect(),
    onChange: function onChange(value) {
      return row.toggleSelected(!!value);
    },
    "aria-label": "Select row",
    "data-cy": 'select-row'
  });
};
exports.RowSelectionCheckbox = RowSelectionCheckbox;
var CheckboxWrapper = exports.CheckboxWrapper = _styledComponents.default.div.withConfig({
  displayName: "RowSelectionCheckbox__CheckboxWrapper",
  componentId: "sc-k6h9ww-0"
})(["> :first-child{padding-right:", ";padding-left:", ";}gap:", ";display:flex;"], _tokens.default.sky.sys.spacing[400], _tokens.default.sky.sys.spacing[200], _tokens.default.sky.sys.spacing[200]);